import { useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import { useLocation } from 'wouter';

function Reports() {
  const { logout } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    logout();
    setLocation('/')
  }, [logout, setLocation]);

  return <div/>;
}

export default Reports;
